import { render, staticRenderFns } from "./RentalClubIndex.vue?vue&type=template&id=61faf485"
import script from "./RentalClubIndex.vue?vue&type=script&lang=ts"
export * from "./RentalClubIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports